const company = {
  company: {
    pageHeader: 'Perfil de la compañía',
    branchProfile: 'Perfil de la sucursal',
    addBranchOffice: 'Añadir una sucursal',
    companyDetails: 'Detalles de la compañía',
    branchDetails: 'Detalles de la sucursal',
    companyName: 'Nombre de la compañía',
    branchName: 'Nombre de la sucursal',
    websiteURL: 'URL del sitio web',
    url: 'URL',
    yearFounded: 'Año que se fundó',
    companyLogo: 'Logotipo de la compañía',
    imageFormatDescription: 'Debe ser un archivo JPEG, GIF o PNG que no supere los 4\xa0MB.',
    imageShapeDescription:
      'Para obtener mejores resultados, te recomendamos que utilices una imagen cuadrada con un fondo transparente de al menos 400 × 400 píxeles.',
    noFile: 'No se ha seleccionado ningún archivo',
    companyDescription: 'Descripción de la compañía',
    myTestEdit: 'Mi edición de prueba',
    customerWelcomeEmail: 'Correo electrónico de bienvenida al cliente',
    testEditMessage: 'mensaje de correo electrónico de edición de prueba',
    companyDescriptionTooltip:
      'El texto que se introduzcas aquí aparecerá en las vistas públicas de los sistemas que instale tu compañía. Quizás sea conveniente que incluyas información de contacto para contribuir a generar más ventas entre los visitantes de estas páginas.',
    editCompanyInformation: 'Editar información de la compañía',
    welcomeEmailDescription:
      'El texto que introduzcas aquí se mostrará en el correo electrónico que se enviará a los nuevos clientes cuando creen una cuenta de Enlighten. Puedes seleccionar si deseas incluir el logotipo de tu compañía con el mensaje.',
    editWelcomeMessage: 'Editar correo electrónico de bienvenida al cliente',
    checkboxDisplayLogo: 'Mostrar logotipo de la compañía en el correo electrónico de bienvenida',
    previewEmail: 'Obtener una vista previa del correo electrónico de bienvenida al cliente',
    contactDetails: 'Detalles de contacto',
    streetAddress: 'Dirección postal',
    streetAddress2: 'Dirección postal 2',
    city: 'Ciudad',
    zipCode: 'Código postal/ZIP',
    customerSupport: 'Contactos de atención al cliente',
    country: 'País',
    state: 'Comunidad Autonoma',
    contactOwnerDescription: 'para el Propietario del sistema / Propietario de vivienda a contactar',
    businessContacts: 'Contactos comerciales',
    sameCheckbox: 'Igual que atención al cliente',
    contactEnphaseDescription: 'para que Enphase se ponga en contacto',
    installationDetails: 'Detalles de la instalación',
    servicesOffered: 'Servicios ofrecidos',
    installationType: 'Tipo de instalación',
    salesEmployeeNumber: 'Cantidad de empleados en Ventas',
    workmanshipWarranty: 'Garantía de fabricación ofrecida (Año)',
    installationEmployeeNumber: 'Cantidad de empleados realizando instalaciones',
    typicalInstallationsYear: 'Instalaciones típicas (por año)',
    typicalInstallationsMonth: 'Instalaciones típicas (kW / Mes)',
    enphaseShare: 'Participación de Enphase en instalaciones',
    sgipDeveloper: '¿Eres un desarrollador de SGIP?',
    sgipDeveloperTooltip: 'Selecciona si estás registrado como un Desarrollador de SGIP en selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'Clave del desarrollador de SGIP',
    businessLicenses: 'Licencias comerciales',
    addNewLicense: 'AÑADIR NUEVA LICENCIA',
    licenseType: 'Tipo de licencia',
    licenseNo: 'No. de licencia',
    none: 'Ninguno',
    licensingBoard: 'Organismo de licencias',
    licensingAuthority: 'Autoridad de licencias',
    expiryDate: 'Fecha de vencimiento',
    profileLinks: 'Enlaces de perfiles',
    yelpAccountLink: 'Enlace de cuenta Yelp',
    rating: 'Clasificación: ',
    reviews: 'Reseñas: ',
    yelpAccountLinkTooltip:
      'Para obtener este enlace, dirígete a tu perfil de Yelp y copia el enlace/URL en la barra de direcciones de tu navegador de Internet',
    yelpAccountLinkError: 'No hemos podido obtener tu perfil de yelp. Revisa el enlace del perfil que introdujiste',
    googlePlaceId: 'Place ID de Google',
    clickHere: 'Haz clic aquí',
    findPlaceId: 'para encontrar tu place ID de Google',
    placeIdError:
      'No pudimos encontrar una ubicación válida para esta identificación. Vuelva a verificar la identificación que ingresó.',
    solarProfileLink: 'Enlace al perfil de SolarReviews ',
    solarProfileLinkTooltip:
      'Para obtener este enlace, dirígete a tu perfil de SolarReviews.com y copia el enlace/URL en la barra de direcciones de tu navegador de Internet',
    bbbProfileLink: 'Enlace al perfil de BBB',
    bbbProfileLinkTooltip:
      'Para obtener este enlace, dirígete a tu perfil de BBB.org y copia el enlace/URL en la barra de direcciones de tu navegador de Internet',
    solarQuotesProfileLink: 'Enlace al perfil de Solarquotes',
    solarQuotesTooltip:
      'Para obtener este enlace, dirígete a tu perfil de solarquotes.com.au y copia el enlace/URL en la barra de direcciones de tu navegador de Internet',
    productReviewProfileLink: 'Enlace al perfil de ProductReview',
    productReviewTooltip:
      'Para obtener este enlace, dirígete a tu perfil de productreview.com.au y copia el enlace/URL en la barra de direcciones de tu navegador de Internet',
    trustPilotLink: 'Enlace de perfil de Trustpilot',
    trustPilotTooltip:
      'Para obtener este enlace, vaya a su perfil de trustpilot.com y copie el enlace/URL en la barra de direcciones de su navegador de Internet.',
    facebookLink: 'Enlace de perfil de Facebook',
    facebookTooltip:
      'Para obtener este enlace, vaya a su perfil de facebook.com y copie el enlace/URL en la barra de direcciones de su navegador de Internet.',
    justDialLink: 'Solo marque el enlace de perfil',
    justDialTooltip:
      'Para obtener este enlace, vaya a su perfil de justdial.com y copie el enlace/URL en la barra de direcciones de su navegador de Internet.',
    listOfReferenceSystems: 'Lista de sistemas de referencia',
    referenceListDescription:
      'Tu lista de referencia se actualiza automáticamente para mostrar los sistemas que los propietarios han elegido compartir. Los sistemas de la lista tienen un mínimo de 100\xa0kWh de energía de vida útil',
    requestSystemAccess: 'Solicitar acceso al sistema',
    maintainer: 'Mantenedor',
    view_only: 'Sólo visualización',
    linkRequestAccess:
      'Envía este vínculo a los propietarios de los sistemas para solicitar acceso a sus sistemas en Enlighten',
    fieldRequired: 'Este campo es obligatorio.',
    validEmail: 'Introduce una dirección de correo electrónico válida.',
    validPhone: 'Introduce un número de teléfono válido.',
    supportContact: 'Rellena al menos uno de los campos anteriores (Teléfono/Correo electrónico).',
    serviceRequired: 'Se requiere al menos un tipo de servicio',
    installationRequired: 'Se requiere al menos un tipo de instalación',
    minLength: 'La longitud mínima permitida es 2',
    maxLength: 'La longitud máxima permitida es 15',
    dateWarning: 'Advertencia: Esta licencia se considerará vencida si la fecha de vencimiento está en el pasado',
    correctValue: 'Introduce un valor menor o igual a\xa0',
    feinLength: 'Introduce un número de 9 dígitos',
    less_than_25: 'Menos de 25%',
    between_25_50: '25% a 50%',
    between_50_90: '50% a 90%',
    greater_than_90: 'Más de 90%',
    roofing: 'Techos',
    solar: 'Solar',
    storage: 'Baterías',
    electrical: 'Instalación eléctrica',
    ev_charger: 'Cargador EV',
    others: 'Otros',
    commercial: 'Comercial',
    residential: 'Residencial',
    new_homes: 'Nuevas casas',
    installer: 'Instalador',
    roles_distributor: 'Distribuidor',
    roles_support: 'Compañía de apoyo',
    cec: 'CEC',
    electrical_contract: 'Contrato eléctrico',
    abn_number: 'Número de ABN',
    acn_number: 'Número de ACN',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Seleccione País',
    yellowPageLink: 'Enlace a la página amarilla',
    yellowPageTooltip: `Para obtener este enlace, vaya a su perfil https://www.pagesjaunes.fr/ y copie el enlace/URL en la barra de direcciones de su navegador de Internet.`,
    enrQualityDirectoryLink: 'Anuario Qualit’Enr',
    enrQualityDirectoryTooltip: `Para obtener este enlace, vaya a su perfil https://www.qualit-enr.org/annuaire/ y copie el enlace/URL en la barra de direcciones de su navegador de Internet.`,
    validChamberNumber: '¡Entrada inválida! Se requiere un mínimo de 8 caracteres para el número de la Cámara de Comercio',
    chamberofcommerce : 'Número de la Cámara de Comercio',
  }
};

export default company;
